window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
    componentRegistry.useComponentPlugin('ProductItem', {
      name: 'Change Product URL Format',
      apply: () => ({
        afterRender(element) {
          let data = element.getParams().props.product;
          const productItem = document.querySelector(`.boost-sd__product-item[id='${data.id}']`);
          initRenderOmnibusInfo(productItem, data);
        },
      }),
    });
  },
]);
function getMetaFields(varianID, product) {
  fetch(`${Shopify.routes.root}variants/${varianID}?sections=variant-metafields`, {
    headers: {
      Accept: 'application/json, text/plain, */*', // It can be used to overcome cors errors
      'Content-Type': 'application/json',
    },
  })
    .then((response) => {
      return response.text();
    })
    .then((text) => {
      const parser = new DOMParser();
      const iJSON = JSON.parse(text);
      const htmlDoc = parser.parseFromString(iJSON['variant-metafields'], 'text/html');
      const { innerHTML } = htmlDoc.getElementById('shopify-section-variant-metafields');
      if (innerHTML.trim().length > 0) {
        const omnibusPrice = JSON.parse(innerHTML.trim().replace(/<\/?[^>]+(>|$)/g, ''))[0];
        const priceWrapper = product.querySelector('.boost-sd__product-price');
        const omnibusInfo = document.createElement('div');
        omnibusInfo.classList.add('boost-sd__omnibus-price');
        if (omnibusPrice.variant_bpi_price && omnibusPrice.variant_bpi_price !== null && omnibusPrice.variant_bpi_price !== 'null') {
          omnibusInfo.textContent = omnibusPrice.variant_bpi_price;
          if (!product.querySelector('.boost-sd__omnibus-price')) {
            if (product.closest('.slick-list')) {
              product.closest('.slick-list').classList.add('set-auto-height');
            }
            priceWrapper.appendChild(omnibusInfo);
            requestAnimationFrame(() => {
              omnibusInfo.style.opacity = '1';
            });
          }
        }
      }
    })
    .catch((err) => console.log(err));
}

function initRenderOmnibusInfo(product, data) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !product.querySelector('.boost-sd__omnibus-price')) {
        if (data.percent_sale_min > 0) {
          getMetaFields(data.variants[0].id, product);
        }
      }
    });
  });
  observer.observe(product);
}
